import axios from "@/api/request.js";
import {
    Loading
} from "element-ui";
/*
  PDF.js盖章调用步骤

  第一步：将需要盖章的pdf的iframe的id和name都改成 pdfviewer
  第二步：data里面申明需要用到的变量：StampModule: null
  第三步：vue页面需要引入
          import {
            fun_StampModule,
            fun_InsertStamp,
            fun_DeleteSelect,
            fun_Init
          } from "@/utils/stampModules";
  第四步：mounted() 页面加载的时候需要加载
        // 给pdf.js加入全局删除方法
        fun_Init(this);
        // 获取初始化参数
        this.StampModule = fun_StampModule();
  第五步：method() 需要加入两个方法
          // 删除盖章时75%没有偏移量的问题 需要将ifarme的名字和主键都改成 pdfviewer
          // 此方法只需要引入，pdf.js加载完后自动调用
          fun_DeleteSelect() {
            fun_DeleteSelect();
          },
          // 显示盖章图片
          fun_InsertStamp() {
            // 获取base64Img字符串
            ...................................
            // 初始化加载 
            fun_InsertStamp(this,base64Img);
          }
  第六步：点击pdf里面的确定盖章按钮会调用StampModule对象里面的_enableShure方法

  注：图片盖章方法和删除盖章方法写在后端的FileUtil共同里面
      public static InputStream getDocumentSeal(InputStream inputStream, InputStream image,double pointX,double pointY,int pageNum)
      public static InputStream deleteImg(InputStream pdf)
*/
/**
 * 初始化参数
 * @returns
 */
export const fun_StampModule = (
    thats,
    file,
    id,
    sealImg,
    pdfPath
) => {
    return {
        stampList: null,
        observer: null,
        initialized: false,
        contentDocument: null,
        PDFViewerApplication: null,
        _setScaleObserver: function () {
            var n = this;
            var e =
                window.MutationObserver ||
                window.WebKitMutationObserver ||
                window.MozMutationObserver;
            if (e) {
                var t = function (e) {
                    e.forEach(function (e) {
                        if (e.type == "attributes") {
                            Object.keys(n.stampList).forEach(function (e) {
                                var t = n.PDFViewerApplication.pdfViewer.getPageView(
                                    n.stampList[e].pageNum - 1
                                );
                                n._insertStampImg(t, n.stampList[e]);
                            });
                        }
                    });
                };
                n.observer = new e(t);
                var i = n.PDFViewerApplication.pdfViewer.getPageView(0);
                n.observer.observe(i.div, {
                    attributes: true,
                    attributeFilter: ["style"],
                    attributeOldValue: true
                });
            } else {
                var i = n.PDFViewerApplication.pdfViewer.getPageView(0);
                i.div.onresize = function () {
                    Object.keys(n.stampList).forEach(function (e) {
                        var t = n.PDFViewerApplication.pdfViewer.getPageView(
                            n.stampList[e].pageNum - 1
                        );
                        n._insertStampImg(t, n.stampList[e]);
                    });
                };
                n.observe = true;
            }
        },
        // _setScrollObserver: function() {
        //   var n = this;
        //   var e = n.contentDocument.getElementById("viewerContainer");
        //   e.onscroll = onScroll;
        //   function onScroll() {
        //     var e = n.PDFViewerApplication.pdfViewer.currentPageNumber;
        //     Object.keys(n.stampList).forEach(function(e) {
        //       var t = n.PDFViewerApplication.pdfViewer.getPageView(
        //         n.stampList[e].pageNum - 1
        //       );
        //       n._insertStampImg(t, n.stampList[e]);
        //     });
        //   }
        // },
        _enableDrag: function (i, a) {
            var o = this;
            var r = 0,
                s = 0;
            var l = 0,
                p = 0;
            var n = i.viewport.scale;
            var e = parseInt(a.style.width, 10);
            var t = parseInt(a.style.height, 10);
            var u = i.pdfPage._pageInfo.view[2];
            var c = i.pdfPage._pageInfo.view[3];
            var v = u - e - 2;
            var d = c - t - 2;
            a.onmousedown = onMouseDown;
            a.addEventListener("touchstart", onMouseDown, false);
            // 点击签章事件
            function onMouseDown(e) {
                e = e || window.event;
                e.preventDefault();
                for (var t = 0; t < i.div.children.length; t++) {
                    i.div.children[t].classList.add("disable-select");
                }
                r = parseInt(a.style.left, 10);
                s = parseInt(a.style.top, 10);
                if (e.changedTouches !== undefined) {
                    var n = e.changedTouches;
                    l = n[0].pageX;
                    p = n[0].pageY;
                } else {
                    // 鼠标相对pdf.js的内框X，Y
                    l = e.clientX;
                    p = e.clientY;
                    a.style.pointerEvents = "none";
                    a.style.cursor = "auto";
                }
                i.div.onmousemove = onMouseMove;
                i.div.onmouseup = onMouseUp;
                o.contentDocument.onmouseup = onMouseUp;
                document.onmouseup = onMouseUp;
                i.div.addEventListener("touchmove", onMouseMove, false);
                i.div.addEventListener("touchend", onMouseUp, false);
            }
            // 移动签章事件
            function onMouseMove(e) {
                e = e || window.event;
                e.preventDefault();
                if (e.changedTouches !== undefined) {
                    var t = e.changedTouches;
                    r = (t[0].pageX - l) / n + r;
                    s = (t[0].pageY - p) / n + s;
                    l = t[0].pageX;
                    p = t[0].pageY;
                } else {
                    // 计算中心点移动了多少
                    var centerX = e.clientX - l + o.stampList[a.id].centerX;
                    var centerY = p - e.clientY + o.stampList[a.id].centerY;
                    // console.log(centerX, centerY, e.clientX, e.clientY, l, p);
                    // 只能在本页的大小里面移动章
                    if (
                        centerX > 0 &&
                        centerX < o.stampList[a.id].allWidth - o.stampList[a.id].width * n
                    ) {
                        o.stampList[a.id].centerX = centerX;
                        r = (e.clientX - l) / (n - 1) + r;
                    }
                    if (
                        centerY > 0 &&
                        centerY <
                        o.stampList[a.id].allHeight -
                        o.stampList[a.id].height * n -
                        o.stampList[a.id].sure * n
                    ) {
                        o.stampList[a.id].centerY = centerY;
                        s = (p - e.clientY) / (n - 1) + s;
                    }
                    // 鼠标相对于pdf.js的内框X，Y
                    l = e.clientX;
                    p = e.clientY;
                }

                // r = r < 0 ? 0 : r > v ? v : r;
                // s = s < 0 ? 0 : s > d ? d : s;
                a.style.left = r + "px";
                a.style.top = s + "px";
                a.style.transformOrigin = 0 - r + "px " + s + "px 0px";
                o.stampList[a.id].left = r;
                o.stampList[a.id].top = s;
                // console.log(r, s);
            }

            function onMouseUp(e) {
                i.div.onmouseup = null;
                i.div.onmousemove = null;
                o.contentDocument.onmouseup = null;
                document.onmouseup = null;
                i.div.removeEventListener("touchmove", onMouseMove, false);
                i.div.removeEventListener("touchend", onMouseUp, false);
                a.style.pointerEvents = "auto";
                for (var t = 0; t < i.div.children.length; t++) {
                    i.div.children[t].classList.remove("disable-select");
                }
            }
        },
        _enableDelete: function (n, i) {
            var a = this;
            i.style.pointerEvents = "auto";
            i.onclick = deleteStamp;
            i.addEventListener("touchend", deleteStamp, false);

            function deleteStamp(e) {
                e = e || window.event;
                e.preventDefault();
                i.onclick = null;
                n.remove();
                a._deleteStamp(n.id);
                var t;
                if (typeof window.CustomEvent === "function") {
                    t = new CustomEvent("removestamp", {
                        bubbles: true,
                        cancelable: true,
                        detail: {
                            stampId: n.id
                        }
                    });
                } else {
                    t = a.contentDocument.createEvent("CustomEvent");
                    t.initCustomEvent("removestamp", true, true, {
                        stampId: n.id
                    });
                }
                a.contentDocument.dispatchEvent(t);
            }
        },
        // 删除所有签章的方法
        deleteAllStamp: function () {
            var a = this;
            var allPage = document
                .getElementById("pdfviewer")
                .contentWindow.document.getElementById("viewer")
                .getElementsByClassName("page");
            for (let ii = 0; ii < allPage.length; ii++) {
                let n = allPage[ii].getElementsByClassName("stamp-img")[0];
                if (n) {
                    let i = allPage[ii]
                        .getElementsByClassName("stamp-img")[0]
                        .getElementsByClassName("cross-div1")[0];
                    i.onclick = null;
                    n.remove();
                    a._deleteStamp(n.id);
                    var t;
                    if (typeof window.CustomEvent === "function") {
                        t = new CustomEvent("removestamp", {
                            bubbles: true,
                            cancelable: true,
                            detail: {
                                stampId: n.id
                            }
                        });
                    } else {
                        t = a.contentDocument.createEvent("CustomEvent");
                        t.initCustomEvent("removestamp", true, true, {
                            stampId: n.id
                        });
                    }
                    a.contentDocument.dispatchEvent(t);
                }
            }
        },
        /**
         * 全局加载
         */
        fun_Loading() {
            thats.fullLoading = Loading.service({
                lock: true,
                text: "盖章中请等候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)"
            });
        },
        // 确定按钮事件
        _enableShure: function (n, b) {
            // var a = this;
            b.style.pointerEvents = "auto";
            b.onclick = getStamp1;
            b.addEventListener("touchend", getStamp1, false);
            const that = this;

            function getStamp1(e) {
                e = e || window.event;
                e.preventDefault();
                var a = JSON.stringify(that.getStamps());
                //取json里面的页码和坐标
                var obj1 = eval(a);
                let formData = new FormData();
                if (file) {
                    // 文件
                    formData.append("file", file);
                }
                // 主键
                formData.append("id", id);
                // X坐标
                formData.append("pointX", obj1[0].x);
                // Y坐标
                formData.append("pointY", obj1[0].y);
                // 当前需要盖章的页面
                formData.append("pageNo", obj1[0].page);
                // 盖章图片
                formData.append("sealImg", sealImg);
                // pdf路径
                formData.append("filePath", pdfPath);
                // 全局加载
                that.fun_Loading();
                // 调用盖章
                that.fun_Submit(thats, formData);
                // 去除所有页面的盖章按钮
                that.deleteAllStamp();
            }
        },
        // 盖章之后的提交操作
        fun_Submit(thats, formData) {
            axios({
                url: "/seal/pdfSeal",
                responseType: "blob",
                timeout: 0,
                method: "post",
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: formData
            }).then(res => {
                if (res) {
                    // 存储this
                    const data = new Blob([res.data], {
                        type: "application/pdf"
                    });
                    // 放入iframe的src里面  重新加载盖章后的pdf
                    document.getElementById("pdfviewer").src =
                        "./static/pdf/web/viewer.html?file=" +
                        encodeURIComponent(URL.createObjectURL(data));
                    // 页面提交
                    thats.fun_SealSubmit();
                    // 关闭全局加载
                    thats.fullLoading.close();
                }
            });
        },
        // 添加图片
        _insertStampImg: function(e, t) {
            // 删除之前的盖章图片
            this.deleteAllStamp();
            if (this.contentDocument.getElementById(t.id)) {
                this.contentDocument.getElementById(t.id).remove();
            }
            var n = this.PDFViewerApplication.pdfViewer.currentPageNumber;
            if (e.div.hasAttribute("data-loaded") || Math.abs(t.pageNum - n) <= 5) {
                var i = this.contentDocument.createElement("div");
                i.className = "stamp-img";
                i.id = t.id;
                i.style.left = t.left + "px";
                i.style.top = t.top + "px";
                i.style.transformOrigin = "0px 0px 0px";
                i.style.transform =
                    "matrix(" +
                    e.viewport.scale +
                    ", 0, 0, " +
                    e.viewport.scale +
                    ", " +
                    t.centerX +
                    ", " +
                    (0 -
                        (t.centerY +
                            t.width * e.viewport.scale +
                            t.sure * e.viewport.scale)) +
                    ")"; // 30是确定取消按钮的高度，centerY是页宽除以2得到的页面垂直中心点，原始坐标原点是在取消按钮的左下角，加上盖章图片的高度乘以倍数、加上确定取消的高度乘以倍数，就是本页的真实中心坐标点。
                i.style.width = t.width + "px";
                i.style.height = t.height + "px";
                i.style.backgroundImage = JSON.parse(JSON.stringify(t.backgroundImage.replace(/\s/g,"")));
                i.style.backgroundSize = t.backgroundSize;
                var bottomDiv = this.contentDocument.createElement("div");
                bottomDiv.style.cssText =
                    "position: relative; bottom: -100%; width: 102%;left:-1px;display: flex;justify-content: flex-start;";
                var a = this.contentDocument.createElement("div");
                a.className = "cross-div1";
                a.style.cssText =
                    "position:relative;flex: 1;line-height: " +
                    t.sure +
                    "px;background:#EEEEEE;cursor:pointer;text-align: center;font-size:14px;";
                a.innerHTML =
                    "<font style='height: 50%;position:relative;top:5%;font-size: 16px;font-family: Source Han Sans SC;font-weight: 400;color: #999999;line-height: 18px;'>取消</font>";
                var b = this.contentDocument.createElement("div");
                b.className = "cross-div2";
                b.style.cssText =
                    "position:relative;flex: 1;line-height: " +
                    t.sure +
                    "px;background:#51B724;cursor:pointer;text-align: center;font-size:14px;";
                b.innerHTML =
                    "<font style='height: 50%;position:relative;top:5%;font-size: 16px;font-family: Source Han Sans SC;font-weight: 400;color: #FFFFFF;line-height: 18px;'>确定</font>";
                bottomDiv.appendChild(a);
                bottomDiv.appendChild(b);
                i.appendChild(bottomDiv);
                e.div.appendChild(i);
                this._enableDrag(e, i);
                this._enableDelete(i, a);
                this._enableShure(i, b);
            }
            // if (null == this.observer) {
            //   this._setScaleObserver();
            //   this._setScrollObserver();
            // }
        },
        _deleteStamp: function(e) {
            if (undefined != this.stampList[e]) {
                delete this.stampList[e];
                this.stampList.length--;
            }
            if (this.stampList.length <= 0 && null != this.observer) {
                var t =
                    window.MutationObserver ||
                    window.WebKitMutationObserver ||
                    window.MozMutationObserver;
                if (t) {
                    this.observer.disconnect();
                    this.observer = null;
                } else {
                    var n = this.PDFViewerApplication.pdfViewer.getPageView(0);
                    n.div.onresize = null;
                    this.observer = null;
                }
                var i = this.contentDocument.getElementById("viewerContainer");
                i.onscroll = null;
            }
        },
        _generateUUID: function() {
            var e = [];
            var t = "0123456789abcdef";
            for (var n = 0; n < 36; n++) {
                e[n] = t.substr(Math.floor(Math.random() * 16), 1);
            }
            e[14] = "4";
            e[19] = t.substr((e[19] & 3) | 8, 1);
            e[8] = e[13] = e[18] = e[23] = "-";
            var i = e.join("");
            return i;
        },
        _handleStampEvent: function(e) {
            var t = this;
            switch (e.type) {
                case "removestamp":
                    if (null != t.contentDocument.onremovestamp) {
                        e.preventDefault();
                        t.contentDocument.onremovestamp(e);
                    }
                    break;
                default:
                    break;
            }
        },
        // 初始化
        initialize: function stampModuleInitialize(e, t) {
            var n = this;
            n.initialized = true;
            n.contentDocument = e;
            n.stampList = new Array();
            n.PDFViewerApplication = t;
            n.contentDocument.onremovestamp = null;
            n.contentDocument.addEventListener(
                "removestamp",
                n._handleStampEvent.bind(n)
            );
            return n;
        },
        // 添加显示盖章图片
        insertStamp: function stampModuleInsertStamp(base64Img, s, t, l, p, n) {
            var u = this;
            var c =
                typeof t === "undefined" || t === 0 ? u.PDFViewerApplication.page : t;
            var v = u.PDFViewerApplication.pdfViewer.getPageView(c - 1);
            var d = "data:image/png;base64," + base64Img;
            var m = new Image();
            m.hidden = true;
            m.onload = function() {
                var e = u._generateUUID();
                var t = s ? s : 96;
                // var n = (72 / t) * m.width;
                // var i = (72 / t) * m.height;
                var n = 120; // 盖章图片的宽
                var i = 120; // 盖章图片的高
                var sure = 30; // 确认取消弹窗高度
                // var a =
                //   typeof l == "undefined"
                //     ? (v.viewport.viewBox[2] - n) / 2
                //     : l - n / 2;
                // var o =
                //   typeof p == "undefined"
                //     ? (v.viewport.viewBox[3] - i) / 2
                //     : p - i / 2;
                var a = typeof l == "undefined" ? v.viewport.viewBox[2] - n : l - n / 2;
                var o = typeof p == "undefined" ? v.viewport.viewBox[3] - i : p - i / 2;
                var r = new Object();
                r.id = e;
                r.pageNum = c;
                r.left = a;
                r.top = o;
                r.left = 0;
                r.top = 0;
                r.sure = sure;
                r.width = n;
                r.height = i;
                // 中心点初始值
                r.centerX = v.viewport.width / 2 - (n * v.viewport.scale) / 2;
                r.centerY = v.viewport.height / 2 - (n * v.viewport.scale) / 2 - sure * v.viewport.scale;
                r.allWidth = v.viewport.width; // 本页总宽
                r.allHeight = v.viewport.height; // 本页总高
                // 放大倍数
                r.scale = v.viewport.scale;
                console.log(r.scale, "===========================倍数");
                r.backgroundImage = "url(" + d + ")";
                r.backgroundSize = r.width + "px" + " " + r.height + "px";
                r.zIndex = 10;
                u.stampList[e] = r;
                u.stampList.length++;
                u._insertStampImg(v, r);
            };
            m.src = d;
        },
        clearStamps: function stampModuleClearStamps() {
            var t = this.stampList;
            var n = this;
            Object.keys(t).forEach(function(e) {
                if (n.contentDocument.getElementById(t[e].id)) {
                    n.contentDocument.getElementById(t[e].id).remove();
                }
                n._deleteStamp(e);
            });
        },
        // 获取签章的参数
        getStamps: function stampModuleGetStamps() {
            var n = new Array();
            var i = this.stampList;
            Object.keys(i).forEach(function(e) {
                var t = new Object();
                t["class"] = "Annotation";
                t.type = "point";
                t.page = i[e].pageNum; // 本页页数
                t.allHeight = i[e].allHeight; // 本页总高
                t.allWidth = i[e].allWidth; // 本页总宽
                // t.x = i[e].left + i[e].width / 2;
                // t.y = i[e].top + i[e].height / 2;
                // 真实的放入pdf插入图片的Y坐标
                t.x = i[e].centerX / i[e].scale;
                // 倍数大于1
                if (i[e].scale > 1) {
                    // 真实的放入pdf插入图片的Y坐标
                    t.y = i[e].centerY / i[e].scale + i[e].width / 2;
                } else {
                    // 真实的放入pdf插入图片的Y坐标
                    t.y = i[e].centerY / i[e].scale + i[e].width / 2;
                }
                n.push(t);
            });
            return n;
        }
        // }
    };
};

/**
 * 盖章初始化显示盖章图片
 * @param {传入调用此方法页面的this} that
 * @param {盖章图片的base64字符串} base64Img
 */
export const fun_InsertStamp = (that, base64Img) => {
    // 初始化加载
    that.StampModule.initialize(
        document.getElementById("pdfviewer").contentDocument,
        window.frames["pdfviewer"].PDFViewerApplication
    );
    // 清除数据
    that.StampModule.clearStamps();
    // 添加图片图片base64
    that.StampModule.insertStamp(base64Img);
};

/**
 * 删除盖章时75%没有偏移量的问题 需要将ifarme的名字和主键都改成 pdfviewer
 */
export const fun_DeleteSelect = () => {
    // 删除75% 因为他的倍数为1 没有偏移量不能使用
    if (
        document.getElementById("pdfviewer") &&
        document
            .getElementById("pdfviewer")
            .contentWindow.document.getElementById("scaleSelect")[6].text === "75%"
    ) {
        document
            .getElementById("pdfviewer")
            .contentWindow.document.getElementById("scaleSelect")[6]
            .remove();
    }
};

/**
 * 初始化删除方法
 */
export const fun_Init = that => {
    // 开启pdf.js删除75% 紧用于盖章页面
    window.openDelete = true;
    // 用于pdf.js执行完后操作的方法
    window.fun_DeleteSelect = that.fun_DeleteSelect; // 这里需要暴露给全局，这样的话，子页面才能调用相对应的方法
};
